export { default } from './QrHero';



// WEBPACK FOOTER //
// ./src/components/templates/QrHero/index.js